import {
    UPDATE_STEP_CUREENT,
} from './types'

export const handleUpdateStep = (data) => {
  return {
    type: UPDATE_STEP_CUREENT,
    data,
  }
}



// WEBPACK FOOTER //
// ./src/actions/step.js